var spoiler_default = {
  "fontElementMap": "Uj5Vk",
  "hideText": "zNfB4",
  "onHoverText": "TtM6M",
  "hideBlock": "-XEAx",
  "smallBlur": "_6KHJf",
  "mediumBlur": "mwVda",
  "largeBlur": "_59Dl6",
  "hideBlock_gallery": "DpAM4",
  "overlay": "uXwaH",
  "overlay_gallery": "_382me",
  "revealSpoilerBtn": "_8blf8",
  "isMobile": "ISZDD",
  "onHoverBtn": "bGDuQ",
  "spoilerWrapper": "o8X3O",
  "spoilerDescription": "_4vQP8",
  "spoilerContainer": "foUVp",
  "spoilerContainer_Gallery": "F-HVc"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
